exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-container[data-v-6d65cbc4]{margin:2px}.tab-container .form-widget-list[data-v-6d65cbc4]{min-height:28px}.tab-container.selected[data-v-6d65cbc4]{outline:2px solid #409eff !important}\n", ""]);

// exports
